import { DEFAULT_THEME_ID } from '@/themes/constants';
import { loadTheme, getCurrentTheme } from '@/utils/theme';

export default {
  namespaced: true,
  state: {
    themeId: DEFAULT_THEME_ID,
    theme: getCurrentTheme(),
  },
  mutations: {
    SET_THEME(state, { themeId, theme }) {
      state.themeId = themeId;
      state.theme = theme;
    },
  },
  actions: {
    /**
     * 根据后台返回的 themeId 切换主题
     * @param {string|number} themeId
     */
    applyTheme({ commit }, themeId) {
      const theme = loadTheme(themeId);
      commit('SET_THEME', { themeId: theme.id, theme });
      return theme;
    },
  },
};
